import {FC, useState} from "react";
import {
  Container,
  ImageWrapper,
  MinusIcon,
  OpenedDescriptionContainer,
} from "./styles";
import PlusIcon from "../../assets/icons/plus.svg";
import {ITypeRadar} from "../../types";
import ReactMarkdown from "react-markdown";
import IconUrl from "../../assets/icons/link-out-bold.svg";

interface Iprops {
  data: React.ReactNode;
  title?: React.ReactNode;
  isOpen?: boolean;
  typeRadar?: ITypeRadar;
  url?: string;
}

export const BlockToggleDescriptionTehnology: FC<Iprops> = ({
  data,
  title,
  isOpen = false,
  typeRadar,
  url,
}) => {
  const [isOpenBlockDesc, setIsOpenBlockDesc] = useState<boolean>(isOpen);
  const toggleDescription = () => {
    setIsOpenBlockDesc((prev) => !prev);
  };
  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <div
          style={
            typeRadar === "fintech"
              ? {color: "#71c6fa", fontSize: 20}
              : typeRadar === "stateInitiative"
              ? {color: "#56B3FF"}
              : {color: "white", fontSize: 20}
          }
        >
          {title}
        </div>
        <ImageWrapper onClick={toggleDescription}>
          {isOpenBlockDesc ? (
            <MinusIcon />
          ) : (
            <img src={PlusIcon} alt="Toggle icon" />
          )}
        </ImageWrapper>
      </div>
      {isOpenBlockDesc && (
        <OpenedDescriptionContainer>
          {typeof data === "string" ? (
            <div style={{color: "white"}}>
              <ReactMarkdown>{data}</ReactMarkdown>

              {url && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#71c6fa",
                      fontWeight: "400",
                      textDecoration: "none",
                    }}
                  >
                    Ссылка на кейс
                  </a>
                  <img src={IconUrl} alt="" />
                </div>
              )}
            </div>
          ) : (
            data
          )}
        </OpenedDescriptionContainer>
      )}
    </Container>
  );
};
